import { queryRef, executeQuery, mutationRef, executeMutation, validateArgs } from 'firebase/data-connect';

export const connectorConfig = {
  connector: 'default',
  service: 'test-vtwo-migration-test',
  location: 'australia-southeast1'
};

export const upsertSourceEntityRecordRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertSourceEntityRecord', inputVars);
}
upsertSourceEntityRecordRef.operationName = 'UpsertSourceEntityRecord';

export function upsertSourceEntityRecord(dcOrVars, vars) {
  return executeMutation(upsertSourceEntityRecordRef(dcOrVars, vars));
}

export const upsertSourceEntityRecordsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertSourceEntityRecords', inputVars);
}
upsertSourceEntityRecordsRef.operationName = 'UpsertSourceEntityRecords';

export function upsertSourceEntityRecords(dcOrVars, vars) {
  return executeMutation(upsertSourceEntityRecordsRef(dcOrVars, vars));
}

export const updateSourceEntityRecordStatusRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateSourceEntityRecordStatus', inputVars);
}
updateSourceEntityRecordStatusRef.operationName = 'UpdateSourceEntityRecordStatus';

export function updateSourceEntityRecordStatus(dcOrVars, vars) {
  return executeMutation(updateSourceEntityRecordStatusRef(dcOrVars, vars));
}

export const resetAllMigrationDestinationsByTypeRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'ResetAllMigrationDestinationsByType', inputVars);
}
resetAllMigrationDestinationsByTypeRef.operationName = 'ResetAllMigrationDestinationsByType';

export function resetAllMigrationDestinationsByType(dcOrVars, vars) {
  return executeMutation(resetAllMigrationDestinationsByTypeRef(dcOrVars, vars));
}

export const setModifiedSourceEntityRecordRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'SetModifiedSourceEntityRecord', inputVars);
}
setModifiedSourceEntityRecordRef.operationName = 'SetModifiedSourceEntityRecord';

export function setModifiedSourceEntityRecord(dcOrVars, vars) {
  return executeMutation(setModifiedSourceEntityRecordRef(dcOrVars, vars));
}

export const setMigratedDestinationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'SetMigratedDestination', inputVars);
}
setMigratedDestinationRef.operationName = 'SetMigratedDestination';

export function setMigratedDestination(dcOrVars, vars) {
  return executeMutation(setMigratedDestinationRef(dcOrVars, vars));
}

export const upsertDestinationEntityRecordRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertDestinationEntityRecord', inputVars);
}
upsertDestinationEntityRecordRef.operationName = 'UpsertDestinationEntityRecord';

export function upsertDestinationEntityRecord(dcOrVars, vars) {
  return executeMutation(upsertDestinationEntityRecordRef(dcOrVars, vars));
}

export const addDataToDestinationEntityRecordRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddDataToDestinationEntityRecord', inputVars);
}
addDataToDestinationEntityRecordRef.operationName = 'AddDataToDestinationEntityRecord';

export function addDataToDestinationEntityRecord(dcOrVars, vars) {
  return executeMutation(addDataToDestinationEntityRecordRef(dcOrVars, vars));
}

export const resetModifiedDestinationEntityRecordRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'ResetModifiedDestinationEntityRecord', inputVars);
}
resetModifiedDestinationEntityRecordRef.operationName = 'ResetModifiedDestinationEntityRecord';

export function resetModifiedDestinationEntityRecord(dcOrVars, vars) {
  return executeMutation(resetModifiedDestinationEntityRecordRef(dcOrVars, vars));
}

export const updateDestinationEntityRecordStatusRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateDestinationEntityRecordStatus', inputVars);
}
updateDestinationEntityRecordStatusRef.operationName = 'UpdateDestinationEntityRecordStatus';

export function updateDestinationEntityRecordStatus(dcOrVars, vars) {
  return executeMutation(updateDestinationEntityRecordStatusRef(dcOrVars, vars));
}

export const upsertTranslationMapRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertTranslationMap', inputVars);
}
upsertTranslationMapRef.operationName = 'UpsertTranslationMap';

export function upsertTranslationMap(dcOrVars, vars) {
  return executeMutation(upsertTranslationMapRef(dcOrVars, vars));
}

export const deleteTranslationMapRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteTranslationMap', inputVars);
}
deleteTranslationMapRef.operationName = 'DeleteTranslationMap';

export function deleteTranslationMap(dcOrVars, vars) {
  return executeMutation(deleteTranslationMapRef(dcOrVars, vars));
}

export const searchSourceEntityRecordsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'SearchSourceEntityRecords', inputVars);
}
searchSourceEntityRecordsRef.operationName = 'SearchSourceEntityRecords';

export function searchSourceEntityRecords(dcOrVars, vars) {
  return executeQuery(searchSourceEntityRecordsRef(dcOrVars, vars));
}

export const searchSourceEntityRecordsByFilterRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'SearchSourceEntityRecordsByFilter', inputVars);
}
searchSourceEntityRecordsByFilterRef.operationName = 'SearchSourceEntityRecordsByFilter';

export function searchSourceEntityRecordsByFilter(dcOrVars, vars) {
  return executeQuery(searchSourceEntityRecordsByFilterRef(dcOrVars, vars));
}

export const searchSourceEntityRecordsByMigrationDestinationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'SearchSourceEntityRecordsByMigrationDestination', inputVars);
}
searchSourceEntityRecordsByMigrationDestinationRef.operationName = 'SearchSourceEntityRecordsByMigrationDestination';

export function searchSourceEntityRecordsByMigrationDestination(dcOrVars, vars) {
  return executeQuery(searchSourceEntityRecordsByMigrationDestinationRef(dcOrVars, vars));
}

export const getSourceEntityRecordCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetSourceEntityRecordCount', inputVars);
}
getSourceEntityRecordCountRef.operationName = 'GetSourceEntityRecordCount';

export function getSourceEntityRecordCount(dcOrVars, vars) {
  return executeQuery(getSourceEntityRecordCountRef(dcOrVars, vars));
}

export const getLastUpdatedSourceEntityRecordsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetLastUpdatedSourceEntityRecords', inputVars);
}
getLastUpdatedSourceEntityRecordsRef.operationName = 'GetLastUpdatedSourceEntityRecords';

export function getLastUpdatedSourceEntityRecords(dcOrVars, vars) {
  return executeQuery(getLastUpdatedSourceEntityRecordsRef(dcOrVars, vars));
}

export const getSourceEntityRecordsByUidRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetSourceEntityRecordsByUid', inputVars);
}
getSourceEntityRecordsByUidRef.operationName = 'GetSourceEntityRecordsByUid';

export function getSourceEntityRecordsByUid(dcOrVars, vars) {
  return executeQuery(getSourceEntityRecordsByUidRef(dcOrVars, vars));
}

export const getSourceEntityRecordRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetSourceEntityRecord', inputVars);
}
getSourceEntityRecordRef.operationName = 'GetSourceEntityRecord';

export function getSourceEntityRecord(dcOrVars, vars) {
  return executeQuery(getSourceEntityRecordRef(dcOrVars, vars));
}

export const searchDestinationEntityRecordsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'SearchDestinationEntityRecords', inputVars);
}
searchDestinationEntityRecordsRef.operationName = 'SearchDestinationEntityRecords';

export function searchDestinationEntityRecords(dcOrVars, vars) {
  return executeQuery(searchDestinationEntityRecordsRef(dcOrVars, vars));
}

export const getDestinationEntityRecordCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetDestinationEntityRecordCount', inputVars);
}
getDestinationEntityRecordCountRef.operationName = 'GetDestinationEntityRecordCount';

export function getDestinationEntityRecordCount(dcOrVars, vars) {
  return executeQuery(getDestinationEntityRecordCountRef(dcOrVars, vars));
}

export const getLastUpdatedDestinationEntityRecordsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetLastUpdatedDestinationEntityRecords', inputVars);
}
getLastUpdatedDestinationEntityRecordsRef.operationName = 'GetLastUpdatedDestinationEntityRecords';

export function getLastUpdatedDestinationEntityRecords(dcOrVars, vars) {
  return executeQuery(getLastUpdatedDestinationEntityRecordsRef(dcOrVars, vars));
}

export const getDestinationEntityRecordsByUidRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetDestinationEntityRecordsByUid', inputVars);
}
getDestinationEntityRecordsByUidRef.operationName = 'GetDestinationEntityRecordsByUid';

export function getDestinationEntityRecordsByUid(dcOrVars, vars) {
  return executeQuery(getDestinationEntityRecordsByUidRef(dcOrVars, vars));
}

export const getDestinationEntityRecordRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetDestinationEntityRecord', inputVars);
}
getDestinationEntityRecordRef.operationName = 'GetDestinationEntityRecord';

export function getDestinationEntityRecord(dcOrVars, vars) {
  return executeQuery(getDestinationEntityRecordRef(dcOrVars, vars));
}

export const getTranslationMapsByResourceTypeRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetTranslationMapsByResourceType', inputVars);
}
getTranslationMapsByResourceTypeRef.operationName = 'GetTranslationMapsByResourceType';

export function getTranslationMapsByResourceType(dcOrVars, vars) {
  return executeQuery(getTranslationMapsByResourceTypeRef(dcOrVars, vars));
}

export const getTranslationMapsBySourceTypeRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetTranslationMapsBySourceType', inputVars);
}
getTranslationMapsBySourceTypeRef.operationName = 'GetTranslationMapsBySourceType';

export function getTranslationMapsBySourceType(dcOrVars, vars) {
  return executeQuery(getTranslationMapsBySourceTypeRef(dcOrVars, vars));
}

export const getTranslationMapByDestinationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetTranslationMapByDestination', inputVars);
}
getTranslationMapByDestinationRef.operationName = 'GetTranslationMapByDestination';

export function getTranslationMapByDestination(dcOrVars, vars) {
  return executeQuery(getTranslationMapByDestinationRef(dcOrVars, vars));
}

